import styled from 'styled-components';

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  section {
    height: 100%;
  }
`;

export const StyledSidebarMenu = styled.div`
  padding: 0.5rem 1rem 0.5rem 1.5rem;
  line-height: 1rem;
  h2 {
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 1rem;
  }
  h3 {
    margin-bottom: 1rem;
    margin-top: -0.5rem;
    font-size: 0.9rem;
  }
  > p {
    color: ${({ theme }) => theme.secondaryTextColor};
  }
`;

export const ImageDetailsPanel = styled.div`
  background-color: ${({ theme }) => theme.secondaryBackgroundColor};
  color: ${({ theme }) => theme.descriptionColor};
  width: 20rem;
  border-radius: 5px;
  padding: 1rem;
  margin-top: 1rem;
  height: fit-content;
  display: flex;
  flex-direction: column;
  z-index: 100;
  text-align: center;
  padding: 0.5rem;
  justify-content: center;
`;
